import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar.jsx';
import BottomNav from '../components/BottomNav.jsx';
import Footer from '../components/Footer.jsx';
import InstallAppButton from '../components/InstallAppButton.jsx';

export default function PublicLayout({ children }) {
  const location = useLocation();
  const isArticle = location.pathname.startsWith('/artikel/');
  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 transition-colors duration-300">
      <Navbar />
      <BottomNav />
      <InstallAppButton />
      <main key={location.pathname} className={`page-enter ${isArticle ? 'pb-0' : 'pb-24 nav-desktop:pb-0'}`}>{children}</main>
      <Footer />
    </div>
  );
}
